import { z } from 'zod';
export const UTMSchema = z.object({
    campaign: z.string().optional(),
    content: z.string().optional(),
    medium: z.string().optional(),
    source: z.string().optional(),
    term: z.string().optional()
});
//# sourceMappingURL=utmSchema.js.map